const hexToRgba = (hex, opacity) => {
    // Remove the # if it exists
    hex = hex.replace("#", "");

    // Parse r, g, b values
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Return in RGBA format with opacity
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export default hexToRgba;